module.exports = __webpack_public_path__ + "img/Illustration-04.28003dfd.png";